module.exports = __webpack_public_path__ + "img/andreinsta.3fa63af9.jpg";